import * as Yup from 'yup';
import { emailRegEx, phoneRegEx } from '@/utils/RegularExpressions/index.tsx';

// Step 0: Homeowner Information
const homeownerInformationSchema = Yup.object({
  homeownerInformation: Yup.object({
    name: Yup.string().trim().max(250, 'Must be less than 250 characters'),
    phone: Yup.string().matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    email: Yup.string().matches(emailRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid email address',
    }),
    currentAddress: Yup.string().trim().max(500, 'Must be less than 500 characters'),
    propertyAddress: Yup.string().trim().max(500, 'Must be less than 500 characters'),
    purchasePrice: Yup.string().trim().max(50, 'Must be less than 50 characters'),
    gender: Yup.string(),
    race: Yup.array().of(Yup.string()),
    cityEmployee: Yup.string(),
  }),
});

// Step 1: Employment & Tax Documents
const employmentTaxSchema = Yup.object({
  employmentTax: Yup.object({
    w2Forms: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 W-2 forms allowed'),
    irs1040Forms: Yup.array().of(Yup.mixed<File>()).max(5, 'Maximum 5 IRS 1040 forms allowed'),
    payStubs: Yup.array().of(Yup.mixed<File>()).max(20, 'Maximum 20 pay stubs allowed'),
  }),
});

// Step 2: Cash Assets & Statements
const cashAssetsSchema = Yup.object({
  cashAssets: Yup.object({
    checkingSavingsStatements: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 statements allowed'),
    cashAppStatements: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 statements allowed'),
    payPalStatements: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 statements allowed'),
    venmoStatements: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 statements allowed'),
    zelleStatements: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 statements allowed'),
    googlePayStatements: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 statements allowed'),
    revolutStatements: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 statements allowed'),
  }),
});

// Step 3: Other Income
const otherIncomeSchema = Yup.object({
  otherIncome: Yup.object({
    pensionDocuments: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 documents allowed'),
    socialSecurityDocuments: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 documents allowed'),
    ssiDocuments: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 documents allowed'),
    otherIncomeDocuments: Yup.array().of(Yup.mixed<File>()).max(10, 'Maximum 10 documents allowed'),
  }),
});

// Step 4: Review
const reviewSchema = Yup.object({
  review: Yup.object(),
});

export const householdIncomeValidationSchema = [
  homeownerInformationSchema,
  employmentTaxSchema,
  cashAssetsSchema,
  otherIncomeSchema,
  reviewSchema,
] as const;
